var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPagetop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d9e021;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pagetop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,48.5A23.5,23.5,0,1,1,48.5,25,23.53,23.53,0,0,1,25,48.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,3A22,22,0,1,1,3,25,22,22,0,0,1,25,3m0-3A25,25,0,1,0,50,25,25.07,25.07,0,0,0,25,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29,
    y: 16,
    width: 2,
    height: 16,
    transform: "translate(-8.18 28.24) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.05 16.22 22.22 19.05 34.95 31.78 37.78 28.95 25.05 16.22 25.05 16.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12,
    y: 23,
    width: 16,
    height: 2,
    transform: "translate(-11.11 21.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.95 16.22 12.22 28.95 15.05 31.78 27.78 19.05 24.95 16.22 24.95 16.22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagetop);
export default __webpack_public_path__ + "static/media/pagetop.fd2060e642dba11c4a5efb86cc2aff3c.svg";
export { ForwardRef as ReactComponent };